import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'attain-spec-kit',
    description:
      'Plan, build, test, and deploy against the Attain Spec Kit data model: specs, requirements, Jira issues, and CI/CD evidence.',
    icon: 'cube',
    name: 'Attain Spec Kit',
    scenarioVariables: [],
    sessionVariables: [
      {
        defaultValue: null,
        description: 'Scopes every page and widget to a single project',
        id: 'projectId',
        name: 'Project',
        type: {
          dimensionId: 'dim::!projects',
          isMultiselect: false,
        },
      },
    ],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
